import React, { PropsWithChildren, useMemo } from "react";
import useFollowSignalsGroup from "@shared/features/onboarding/hooks/useFollowSignalsGroup";
import { GroupsPageContext } from "@shared/features/groups/GroupsPage.context";

interface GroupsPageProviderProps extends PropsWithChildren {
  isGroupsPage?: boolean;
  discoveryExchange?: string;
  searchValue?: string;
}

const GroupsPageProvider = ({
  isGroupsPage,
  discoveryExchange,
  children,
}: GroupsPageProviderProps) => {
  const {
    myGroupsData,
    freeTrialGroupsData,
    personalGroupsData,
    freeGroupsData,
    noExternalAccountConnected,
    groupIdToNumBots,
    refetch,
  } = useFollowSignalsGroup({ isGroupsPage, discoveryExchange });

  const value = useMemo(() => {
    return {
      myGroupsData,
      freeTrialGroupsData,
      personalGroupsData,
      freeGroupsData,
      isGroupsPage,
      noExternalAccountConnected,
      groupIdToNumBots,
      refetch,
    };
  }, [
    myGroupsData,
    freeTrialGroupsData,
    personalGroupsData,
    freeGroupsData,
    isGroupsPage,
    noExternalAccountConnected,
    groupIdToNumBots,
  ]);

  return (
    <GroupsPageContext.Provider value={value}>
      {children}
    </GroupsPageContext.Provider>
  );
};

export default GroupsPageProvider;
